import React from 'react';
import Breadcrumb from '../../components/breadcrumb';
import logo_dark from '../../assets/images/logos/uniq_dark.svg?url';
import logo_light from '../../assets/images/logos/uniq_light.svg?url';
import packageJson from '../../../package.json';
import { BREADCRUMB_ROOT } from '../../common/config';
import './style.scss';

const AboutPage = () => {
  const preferredLogo = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? logo_dark : logo_light;

  return (
    <div className="layout-content">
      <Breadcrumb crumbs={[BREADCRUMB_ROOT, 'About']} />
      <h1>About</h1>
      
      {/* Support Section */}
      <div className="about-section">
        <h2>Support</h2>
        <div className="about-content">
          <div className="about-item">
            <div className="about-icon clock">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M15.375 14.25L12 13.125V8.42087M21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C12.5768 21 13.1409 20.9457 13.6875 20.8421M15.9375 18.1875L17.625 19.875L22.125 15.375" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <div className="about-text">
              <div className="about-title">Servicezeiten</div>
              <div className="about-subtitle">Montag bis Freitag</div>
              <div className="about-subtitle">7:30 bis 17:30 Uhr</div>
            </div>
          </div>
          
          <div className="about-item">
            <div className="about-icon phone">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M20.6633 18.771C20.6633 18.771 19.5047 19.909 19.2207 20.2427C18.7582 20.7363 18.2132 20.9693 17.4988 20.9693C17.4301 20.9693 17.3568 20.9693 17.2881 20.9648C15.9279 20.8779 14.6639 20.3478 13.7159 19.8953C11.1238 18.643 8.84771 16.8652 6.95629 14.612C5.39461 12.7336 4.35044 10.9969 3.65891 9.13217C3.233 7.99415 3.07729 7.1075 3.14598 6.27113C3.19178 5.7364 3.39787 5.29308 3.77798 4.91374L5.33966 3.35526C5.56406 3.14502 5.80221 3.03076 6.03577 3.03076C6.32429 3.03076 6.55786 3.20443 6.70441 3.35069C6.70899 3.35526 6.71357 3.35983 6.71815 3.3644C6.99751 3.62491 7.26313 3.89456 7.54249 4.18249C7.68446 4.32874 7.83101 4.47499 7.97756 4.62581L9.22782 5.87351C9.71327 6.35797 9.71327 6.80586 9.22782 7.29032C9.09501 7.42286 8.96678 7.5554 8.83397 7.68337C8.44927 8.07642 8.75147 7.77483 8.35304 8.13132C8.34388 8.14046 8.33472 8.14503 8.33014 8.15417C7.93629 8.54722 8.00956 8.93113 8.092 9.19164C8.09658 9.20535 8.10116 9.21906 8.10573 9.23277C8.43089 10.0189 8.88886 10.7593 9.58498 11.6413L9.58956 11.6459C10.8536 13.1998 12.1862 14.411 13.6563 15.3387C13.8441 15.4576 14.0364 15.5536 14.2196 15.645C14.3845 15.7272 14.5402 15.8049 14.673 15.8872C14.6913 15.8963 14.7097 15.91 14.728 15.9192C14.8837 15.9969 15.0302 16.0334 15.1814 16.0334C15.5615 16.0334 15.7996 15.7958 15.8775 15.7181L16.7752 14.8222C16.9309 14.6668 17.1782 14.4795 17.4667 14.4795C17.7506 14.4795 17.9842 14.6577 18.1262 14.8131C18.1308 14.8177 18.1308 14.8177 18.1353 14.8222L20.6587 17.3405C21.1305 17.8067 20.6633 18.771 20.6633 18.771Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <a href="tel:+41448386444" className="about-text about-link">+41 44 838 64 44</a>
          </div>
          
          <div className="about-item">
            <div className="about-icon email">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M4.6875 6.75L11.3596 11.5403C11.7449 11.8168 12.2551 11.8168 12.6404 11.5403L19.3125 6.75M5.25 19H18.75C19.9926 19 21 17.9553 21 16.6667V7.33333C21 6.04467 19.9926 5 18.75 5H5.25C4.00736 5 3 6.04467 3 7.33333V16.6667C3 17.9553 4.00736 19 5.25 19Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <a href="mailto:support@uniqconsulting.ch" className="about-text about-link">support@uniqconsulting.ch</a>
          </div>
        </div>
      </div>
      
      <div className="about-divider"></div>

      {/* Contact Section */}
      <div className="about-section">
        <h2>Kontakt</h2>
        <div className="about-content">
          <div className="about-item">
            <div className="about-icon home">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
                <polyline points="9 22 9 12 15 12 15 22"/>
              </svg>
            </div>
            <div className="about-text">
              <div className="about-title">uniQconsulting ag</div>
              <div className="about-subtitle">Wülflingerstrasse 5</div>
              <div className="about-subtitle">CH-8472 Seuzach</div>
            </div>
          </div>
          
          <div className="about-item">
            <div className="about-icon phone">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M20.6633 18.771C20.6633 18.771 19.5047 19.909 19.2207 20.2427C18.7582 20.7363 18.2132 20.9693 17.4988 20.9693C17.4301 20.9693 17.3568 20.9693 17.2881 20.9648C15.9279 20.8779 14.6639 20.3478 13.7159 19.8953C11.1238 18.643 8.84771 16.8652 6.95629 14.612C5.39461 12.7336 4.35044 10.9969 3.65891 9.13217C3.233 7.99415 3.07729 7.1075 3.14598 6.27113C3.19178 5.7364 3.39787 5.29308 3.77798 4.91374L5.33966 3.35526C5.56406 3.14502 5.80221 3.03076 6.03577 3.03076C6.32429 3.03076 6.55786 3.20443 6.70441 3.35069C6.70899 3.35526 6.71357 3.35983 6.71815 3.3644C6.99751 3.62491 7.26313 3.89456 7.54249 4.18249C7.68446 4.32874 7.83101 4.47499 7.97756 4.62581L9.22782 5.87351C9.71327 6.35797 9.71327 6.80586 9.22782 7.29032C9.09501 7.42286 8.96678 7.5554 8.83397 7.68337C8.44927 8.07642 8.75147 7.77483 8.35304 8.13132C8.34388 8.14046 8.33472 8.14503 8.33014 8.15417C7.93629 8.54722 8.00956 8.93113 8.092 9.19164C8.09658 9.20535 8.10116 9.21906 8.10573 9.23277C8.43089 10.0189 8.88886 10.7593 9.58498 11.6413L9.58956 11.6459C10.8536 13.1998 12.1862 14.411 13.6563 15.3387C13.8441 15.4576 14.0364 15.5536 14.2196 15.645C14.3845 15.7272 14.5402 15.8049 14.673 15.8872C14.6913 15.8963 14.7097 15.91 14.728 15.9192C14.8837 15.9969 15.0302 16.0334 15.1814 16.0334C15.5615 16.0334 15.7996 15.7958 15.8775 15.7181L16.7752 14.8222C16.9309 14.6668 17.1782 14.4795 17.4667 14.4795C17.7506 14.4795 17.9842 14.6577 18.1262 14.8131C18.1308 14.8177 18.1308 14.8177 18.1353 14.8222L20.6587 17.3405C21.1305 17.8067 20.6633 18.771 20.6633 18.771Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <a href="tel:+41448386464" className="about-text about-link">+41 44 838 64 64</a>
          </div>
          
          <div className="about-item">
            <div className="about-icon link">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M10.0115 7.45264L6.85292 7.45264C5.67327 7.45264 4.53155 7.91599 3.6943 8.76564C2.85705 9.61528 2.38138 10.7545 2.40046 11.971C2.38133 13.1875 2.85719 14.3269 3.6943 15.1764C4.55051 16.0453 5.65413 16.5088 6.83382 16.5088H9.9924M13.9883 16.5474H17.1469C18.3265 16.5474 19.4683 16.084 20.3055 15.2344C21.1428 14.3847 21.6184 13.2455 21.5993 12.029C21.5993 10.8319 21.1237 9.69263 20.2864 8.84298C19.4492 7.99333 18.3266 7.51062 17.1469 7.5106H13.9883M7.25235 11.9578L16.7281 11.9578" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <a href="https://www.uniqconsulting.ch" className="about-text about-link">www.uniqconsulting.ch</a>
          </div>
          
          <div className="about-item">
            <div className="about-icon email">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M4.6875 6.75L11.3596 11.5403C11.7449 11.8168 12.2551 11.8168 12.6404 11.5403L19.3125 6.75M5.25 19H18.75C19.9926 19 21 17.9553 21 16.6667V7.33333C21 6.04467 19.9926 5 18.75 5H5.25C4.00736 5 3 6.04467 3 7.33333V16.6667C3 17.9553 4.00736 19 5.25 19Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <a href="mailto:info@uniqconsulting.ch" className="about-text about-link">info@uniqconsulting.ch</a>
          </div>
        </div>
      </div>
      
      <div className="about-divider"></div>

      {/* Presented by Section */}
      <div className="about-section">
        <h2>Presented by</h2>
        <div className="about-logo">
          <img src={preferredLogo} alt="uniQconsulting logo" />
        </div>
      </div>

      <div className="about-divider"></div>

      {/* Version Section */}
      <div className="about-section">
        <h2>Version</h2>
        <div className="about-version">
          v{packageJson.version}
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
